import baseConfig from "../../utils/config";

// Route "/" - Public demo (demo.cadviewer.com).
// Inherits the base demo configuration from src/utils/config.ts
// (production back-end, branding, presentation colours, popups, menus)
// and only keeps the few overrides specific to this public deployment.
const defaultConfig = {
  ...baseConfig,

  AppName: "CADViewer: CADViewer Public Demo ", //"CADViewer: Visual Query  ", //"License Keys: CADViewer Conversion Server / TailorMade REST-API Conversion Server", //"Tenants Overview Plans - Current Floor-plan", //"Standard Visual Query encapsulation of CADViewer", //"Tenants Overview Plans - Current Floor-plan", //"Standard Visual Query encapsulation of CADViewer", // "Comparez les dessins d'infrastructures ferroviaires", // BPRetail "Tenants Overview Plans - Current Floor-plan",   //  "CADViewer: Visual Query ",     // Tenants Overview Plans  &nbsp;&nbsp;- &nbsp;&nbsp;Current Floor-plan:
  ContactEmailsFlag: true, // set to true to display contact emails in the about box
  ContactEmails: [
    "developer@tailormade.com",
    "internationalsales@tailormade.com",
  ],
  ZoomFactor: 25.0, // zoom factor for cvjs_zoomHere_ObjectId() in left panel click
  //"ServerBackEndUrl": "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerBackEndUrl: "https://server.demo.cadviewer.com", //"http://localhost:3000", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  postFixServerToken: false, // true if the server shall be contatenated with a Token, kept on the Server, use a postfixed SAS token, when loading JSON content
  bearerToken: "", //"Bearer t-7614f875-8423-4f20-a674-d7cf3096290e", // "",   // security bearer token (if not applicable, set to "")

  debugMode: true, // enables CADViewer debug traces in the browser

  setCADViewerLanguage: "English", // Available languages:  "English" ; "French, "Korean", "Spanish", "Portuguese", "Chinese-Simplified", "Chinese-Traditional"

  // "initFileName":"/content/drawings/dwg/1st floor architectural.dwg",  // the initialization drawing when loading Visual Query, based on a server path
  initFileName: "/content/demo_user/1st floor architectural_01.dwg", //"/content/custom/bpretail/bpretail-splash-05.svg", // the initialization drawing when loading Visual Query, based on a server path
  // "initFileName":"", // initial drawing to load, if empty, no drawing is loaded

  // "initFileName":"/content/drawings/dwg/1st floor architectural.dwg", // initial drawing to load, if empty, no drawing is loaded
  canvasMode: "SINGLE", // SINGLE || MULTIPLE

  UploadNewFile: "Upload new file(s) to MY FOLDER", //""Upload new file", // text for upload new file button

  activateCompareOnLoad: false,
  // false is default,  activate the compare tool on load  example call: http://localhost:3001/?compareFile=/nodejs/cadviewer-conversion-server/content/drawings/dwg_compare_drawings/hq17-1.dwg&compareWith=/nodejs/cadviewer-conversion-server/content/drawings/dwg_compare_drawings/hq17-2.dwg
  // false is default,  activate the compare tool on load  example call: http://localhost:3001/?compareFile=/nodejs/cadviewer-conversion-server/content/custom/SNCF/S0001A-0001-830014-VIP22%201.dwg&compareWith=/nodejs/cadviewer-conversion-server/content/custom/SNCF/S0001A-0001-830014-VIP22%202.dwg
  // cadviewer license key

  //    "cadviewerLicenseKey" : "00110010 00110010 00110000 00110001 00110010 00110000 00110110 00110001 00110100 00111000 00110001 00110100 00110101 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110100 00111000 00110001 00110101 00110010 00110001 00110100 00110101 00110001 00110100 00110001 00110001 00110100 00110000 00110001 00111001 00111000 00110010 00110000 00110110 00110010 00110000 00111000 00110010 00110000 00110110 00110010 00110000 00110011 00110010 00110001 00110001 00110010 00110000 00111000 00110010 00110000 00110110 00110010 00110001 00110001 00110010 00110000 00110110 00110010 00110000 00110000 00110001 00111001 00111000 00110001 00110100 00110001 00110001 00110100 00110100 00110001 00110101 00111001 00110001 00110101 00110111 00110001 00110101 00110101",
  cadviewerLicenseKey: "00110101",

  // conversion parameters - these can dynamically be change in the settings modal
  //    "conversionParameters" :[{"param":"model", "value": ""}, {"param":"extents", "value": ""}, {"param":"trace", "value": ""}, {"param":"strokeall", "value": ""}, {"param":"SVGTOL", "value": "0.001"}],
  //    "conversionParameters" :[{"param":"last", "value": ""},{"param":"ial", "value": ""}],

  //&    "conversionParameters" :[{"param":"last", "value": ""},{"param":"extents", "value": ""},{"param":"rl", "value": "SF-TENANT-PL;SF-TENANT-PL-ALT"},{"param":"tl", "value": "BI-TEXT;BI-TEXT-ALT"},{"param":"q", "value": ""}, {"param":"ial", "value": ""}, {"param":"lws", "value": "0.33"}],
  //    "conversionParameters" :[{"param":"last", "value": ""},{"param":"extents", "value": ""},{"param":"rl", "value": "SF-TENANT-PL;SF-TENANT-PL-ALT"},{"param":"tl", "value": "BI-TEXT;BI-TEXT-ALT"},{"param":"q", "value": ""}, {"param":"ial", "value": ""}, {"param":"lws", "value": "1.0"}],
  //    "conversionParameters" :[{"param":"layout", "value": "layout1"}, {"param":"extents", "value": ""}, {"param":"trace", "value": ""}, {"param":"hlall", "value": ""}],
  /*
  conversionParameters: [
    { param: "last", value: "" },
    { param: "extents", value: "" },
    { param: "rl", value: "SF-TENANT-PL;SF-TENANT-PL-ALT;PDF_Geometry" },
    { param: "tl", value: "BI-TEXT;BI-TEXT-ALT;PDF_Text" },
    { param: "q", value: "" },
    { param: "ial", value: "" },
    { param: "lws", value: "1.0" },
  ],
*/
  conversionParameters: [
    { param: "last", value: "" },
    { param: "extents", value: "" },
    { param: "rl", value: "RM_" },
    { param: "tl", value: "RM_TXT" },
    { param: "ial", value: "" },
  ],

  // set layer colors on load  - mira
  //    "defaultLayerColorsOnLoad" :[{"layer":"0","color":"#000"},{"layer":"HIDDEN","color":"#000"},{"layer":"Border","color":"#000"},{"layer":"Title BLock","color":"#000"},{"layer":"TEXT","color":"#000"},{"layer":"PIPE2","color":"#000"},{"layer":"EQUIP","color":"#000"},{"layer":"PIPE","color":"#000"}, {"layer":"INST","color":"#000"},{"layer":"ELECT2","color":"#000"},{"layer":"HIDDEN","color":"#000"}],
  //  bp
  //     "defaultLayerColorsOnLoad" :[{"layer":"0","color":"#000"},{"layer":"ARCH-DOORS-EXTERIOR","color":"#000"},{"layer":"ARCH-DOORS-INTERIOR","color":"#000"},{"layer":"ARCH-FEATURES","color":"#000"},{"layer":"ARCH-OPENINGS-ABOVE","color":"#000"},{"layer":"ARCH-OPENINGS-BELOW","color":"#000"},{"layer":"ARCH-SITE-MISCELLANEOUS","color":"#000"},{"layer":"ARCH-SYMBOLS","color":"#000"},{"layer":"ARCH-WALLS-EXTERIOR","color":"#000"},{"layer":"ARCH-WALLS-INTERIOR","color":"#000"},{"layer":"BD-STORAGE","color":"#000"},{"layer":"TABLE-ACREAGE","color":"#000"},{"layer":"SITE-BUILDING","color":"#000"},{"layer":"SITE-CURB","color":"#000"},{"layer":"SITE-PARKING","color":"#000"},{"layer":"TABLE-PARKING-DATA","color":"#000"},{"layer":"SITE-PROPERTY-LINE","color":"#000"},{"layer":"SITE-SIDEWALK","color":"#000"},{"layer":"SITE-MISCELLANEOUS","color":"#000"},{"layer":"SITE-STRIPING","color":"#000"},{"layer":"SITE-TEXT","color":"#000"},{"layer":"DIMENSIONS-STRUCTURAL-GRID","color":"#000"},{"layer":"DIMENSIONS-TENANT","color":"#000"},{"layer":"STRUCTURAL-EXPANSION-JOINT","color":"#000"},{"layer":"KIOSK-SF","color":"#000"},{"layer":"TENANT-SPNO","color":"#000"},{"layer":"TENANT-SF","color":"#000"},{"layer":"KIOSK-NAME","color":"#000"},{"layer":"TENANT-OCCUPANCY-COST","color":"#000"},{"layer":"TENANT-R12-SALES","color":"#000"},{"layer":"TENANT-NAME","color":"#000"},{"layer":"STRUCTURAL-SHEAR-WALL","color":"#000"},{"layer":"STRUCTURAL-BRACING","color":"#000"},{"layer":"STRUCTURAL-COLUMNS","color":"#000"},{"layer":"STRUCTURAL-GRID-TAGS","color":"#000"},{"layer":"ARCH-WALLS-DEMISING","color":"#000"},{"layer":"TENANT-STOREFRONT-LEASELINE","color":"#000"},{"layer":"TEXT-GENERAL","color":"#000"},{"layer":"TEXT-MISCELLANOUS","color":"#000"},{"layer":"TEXT-NOTES","color":"#000"},{"layer":"TITLEBLOCK","color":"#000"},{"layer":"UTILITIES-ELECTRICAL","color":"#000"},{"layer":"UTILITIES-EQUIPMENT","color":"#000"},{"layer":"UTILITIES-HVAC","color":"#000"},{"layer":"UTILITIES-PLUMBING","color":"#000"},{"layer":"KIOSK-SPNO","color":"#000"},{"layer":"XREF","color":"#000"}],
  // bp - new
  setBPLayerChange: false, // SET custom HEADER for BP Retail Layer Change  - 10.55.2
  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "ARCH-DOORS-EXTERIOR", color: "#000" },
    { layer: "ARCH-DOORS-INTERIOR", color: "#000" },
    { layer: "ARCH-FEATURES", color: "#000" },
    { layer: "ARCH-OPENINGS-ABOVE", color: "#000" },
    { layer: "ARCH-OPENINGS-BELOW", color: "#000" },
    { layer: "ARCH-SITE-MISCELLANEOUS", color: "#000" },
    { layer: "ARCH-SYMBOLS", color: "#000" },
    { layer: "ARCH-WALLS-EXTERIOR", color: "#000" },
    { layer: "ARCH-WALLS-INTERIOR", color: "#000" },
    { layer: "BD-STORAGE", color: "#000" },
    { layer: "TABLE-ACREAGE", color: "#000" },
    { layer: "SITE-BUILDING", color: "#000" },
    { layer: "SITE-CURB", color: "#000" },
    { layer: "SITE-PARKING", color: "#000" },
    { layer: "TABLE-PARKING-DATA", color: "#000" },
    { layer: "SITE-PROPERTY-LINE", color: "#000" },
    { layer: "SITE-SIDEWALK", color: "#000" },
    { layer: "SITE-MISCELLANEOUS", color: "#000" },
    { layer: "SITE-STRIPING", color: "#000" },
    { layer: "SITE-TEXT", color: "#000" },
    { layer: "DIMENSIONS-STRUCTURAL-GRID", color: "#000" },
    { layer: "DIMENSIONS-TENANT", color: "#000" },
    { layer: "STRUCTURAL-EXPANSION-JOINT", color: "#000" },
    { layer: "KIOSK-SF", color: "#000" },
    { layer: "TENANT-SPNO", color: "#000" },
    { layer: "TENANT-SF", color: "#000" },
    { layer: "KIOSK-NAME", color: "#000" },
    { layer: "TENANT-OCCUPANCY-COST", color: "#000" },
    { layer: "TENANT-R12-SALES", color: "#000" },
    { layer: "TENANT-NAME", color: "#000" },
    { layer: "STRUCTURAL-SHEAR-WALL", color: "#000" },
    { layer: "STRUCTURAL-BRACING", color: "#000" },
    { layer: "STRUCTURAL-COLUMNS", color: "#000" },
    { layer: "STRUCTURAL-GRID-TAGS", color: "#000" },
    { layer: "ARCH-WALLS-DEMISING", color: "#000" },
    { layer: "TENANT-STOREFRONT-LEASELINE", color: "#000" },
    { layer: "TEXT-GENERAL", color: "#000" },
    { layer: "TEXT-MISCELLANOUS", color: "#000" },
    { layer: "TEXT-NOTES", color: "#000" },
    { layer: "TITLEBLOCK", color: "#000" },
    { layer: "UTILITIES-ELECTRICAL", color: "#000" },
    { layer: "UTILITIES-EQUIPMENT", color: "#000" },
    { layer: "UTILITIES-HVAC", color: "#000" },
    { layer: "UTILITIES-PLUMBING", color: "#000" },
    { layer: "KIOSK-SPNO", color: "#000" },
    { layer: "XREF", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-EQUIPMENT", color: "#000" },
    { layer: "ARCH-CORPORATE-OFFICE-GLAZING", color: "#000" },
    { layer: "FURNITURE-CORPORATE-OFFICE-BLACK", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-CONFERENCE-ROOM-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-ENCLAVE-PL", color: "#000" },
    { layer: "SF-CORPORATE-OFFICE-STORAGE-PL", color: "#000" },
    { layer: "TEXT-CORPORATE-OFFICE-FLOOR-IDENTIFICATION", color: "#000" },
  ],

  defaultLayerSetTimeout: 50, // in milliseconds
  currentView: [], // placeholder for the current view, set by the view menu

  // VISUAL QUERY PANEL CONTROLS
  ShowInformativeBottomPanel: false, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "withCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height

  // print pdf controls
  printPDFflag: false, // add/remove checkbox for print as pdf
  printAsPDF: false, // force server side conversion to pdf
  setPaperSize: "letter", // "A4"  , "letter"    set the papersize on the print modal
  // printer controls
  printMargins_nonprint_h: 10, // non print margin region vertical, default 10mm
  printMargins_nonprint_w: 10, // non print margin region horizontal, default 10mm
  printMargins_standard_h: 18, // non print margin region horizontal, default 18mm
  printMargins_standard_w: 8, // non print margin region vertical, default 8mm
  printMargins_tiny_h: 10, // non print margin region horizontal, default 6mm
  printMargins_tiny_w: 6, // non print margin region vertical, default 6mm
  printMargins_none_h: 0, // no margins, default 0mm
  printMargins_none_w: 0, // no margins, default 0mm
  // "printMargins_custom_h": "10mm", // custom margin region horizontal

  // CADVIEWER MENU CONTROLS
  DisplayCoordinatesMenu: true, // display the CADViewer coordinates menu
  displayTopNavigationBar: true, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: true, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: true, // hide the left hamburger menu

  // TOP NAVIGATION BAR CONTROLS
  displayTopMenuIconBar: true, // display the top menu icon bar
  setTopMenuXMLDirect: true, //true          // determines if XML menu is loaded from file or passed over from sting expression
  // controls for loading top icon menu from server
  topMenuXML: "cadviewer_full_commands_01.xml", //"cadviewer_minimum_viewonly_svg_02.xml",        // menu configuration file used  - default is: cadviewer_full_commands_01.xml   cadviewer_viewonly_nofileload_01.xml
  topMenuXMLpath: "/cadviewer/app/cv/cv-pro/menu_config/", //  the path for XML config files no nodejs conversion server           "/cadviewer/app/cv/cv-pro/menu_config/"
  // top xml icon menu config file for direct insertion

  // zoom controls for bitmap wallpaper
  setZoomImageWallpaper: false, // set the zoom image wallpaper
  setZoomImageWallpaper_scalefactor: 1.0, // set the zoom image wallpaper scale factor , fixed at 1.0
  setZoomImageWallpaper_scalebreakpoint: 0.3, // set the zoom image wallpaper switch breakpoint

  // control og mouse wheel operations
  setScrollWheelThrottleDelay: 200, // millisec scroll throttle delta
  setScrollWheelZoomSteps: 0, // zoom steps, omit zoom wheel interaction,
  setScrollWheelDefaultZoomFactor: 1.2, // default zoom factor for scroll wheel

  // fixed line weight controls
  setNormalizeFixedLineWeights: false, // adjust fixed line weights
  setNormalizeFixedLineWeightsFactor: 2, // global scale factor for fixed line weights

  //                 <command>cvjs_compareDrawings_LoadSecondDrawing</command>

  // page 1   <command>cvjs_interactiveLayerOff</command>  removed from interface
  // page 2                  <command>cvjs_mergeDXFDWG</command>    <command>cvjs_mergeQR</command> removed from interface

  // FOR DEMO MODE WE PREVENT SAVE OF REDLINES, SPACE OBJECTS AND IMAGE LINKS

  topMenuXML_config_file: `
    <cvjs>
    <iconmenu>
        <totalpages>3</totalpages>
        <startpage>1</startpage>
        <pages>
            <page>
                <command>cvjs_customCommand_19</command>
                <command>cvjs_Print</command>
                <command>cvjs_LayerList</command>
                <command>cvjs_interactiveLayerOff</command>
                <command>cvjs_swapLayersInDrawing</command>
                <command>cvjs_allLayersInDrawingOn</command>
                <command>cvjs_toggleBlackWhite</command>
                <command>cvjs_setBackgroundColor</command>
                <command>cvjs_interactiveSearchText</command>
                <command>cvjs_Measurement</command>
                <command>cvjs_calibrateMeasurement</command>
                <command>cvjs_displayMagnifyingGlass</command>
                <command>cvjs_activateLineThicknessModal</command>
                <command>cvjs_compareDrawings_LoadSecondDrawing</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
                </page>
            <page>
                <command>cvjs_loadStickyNotesRedlinesUser</command>
                <command>cvjs_customCommand_10</command>
                <command>cvjs_publishPDF</command>
                <command>cvjs_saveAsSVGOnServer</command>
                <command>cvjs_setRedlineColor</command>
                <command>cvjs_setRedlineThickness</command>
                <command>cvjs_drawStickyNote</command>
                <command>cvjs_drawRedlineText</command>
                <command>cvjs_drawRedline_Freehand</command>
                <command>cvjs_drawRedlineSingleLine</command>
                <command>cvjs_drawRedlineEllipseCloud</command>
                <command>cvjs_drawRedlineFilledPolygon</command>
                <command>cvjs_drawRedlinePolyline</command>
                <command>cvjs_drawRedlineFilledRectangle</command>
                <command>cvjs_drawRedlineRectangle</command>
                <command>cvjs_drawRedlineTriangle</command>
                <command>cvjs_drawRedlineArrow</command>
                <command>cvjs_moveRedline</command>
                <command>cvjs_resizeRedline</command>
                <command>cvjs_rotateRedline</command>
                <command>cvjs_deleteSingleRedline</command>
                <command>cvjs_deleteLastRedline</command>
                <command>cvjs_undoDeleteLastRedline</command>
                <command>cvjs_clearCurrentRedline</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
            </page>
            <page>
                <command>cvjs_customCommand_19</command>
                <command>cvjs_loadSpaceObjectsUser</command>
                <command>cvjs_customCommand_12</command>
                <command>cvjs_saveAsSVGOnServer</command>
                <command>cvjs_changeSpaceObjectDisplayMode</command>
                <command>cvjs_addPolygonSpaceObject</command>
                <command>cvjs_addRectangleSpaceObject</command>
                <command>cvjs_addCircleSpaceObject</command>
                <command>cvjs_copyCircleSpaceObject</command>
                <command>cvjs_resizeSpaceObject</command>
                <command>cvjs_moveSpaceObject</command>
                <command>cvjs_rotateSpaceObject</command>
                <command>cvjs_deleteSpaceObject</command>
                <command>cvjs_clearSpaceObjects</command>
                <command>cvjs_bringToFront</command>
                <command>cvjs_sendToBack</command>
                <command>cvjs_bringForward</command>
                <command>cvjs_sendBackward</command>
                <command>cvjs_insertImageLink</command>
                <command>cvjs_loadAllImageLinks</command>
                <command>cvjs_customCommand_11</command>
                <command>cvjs_clearAllImageLinks</command>
                <command>cvjs_quickCount</command>
                <command>cvjs_showMeCounts</command>
                <command>cvjs_clearQuickCounts</command>
                <command>cvjs_LayerListSpace</command>
                <command>cvjs_swapLayersInDrawing</command>
                <command>cvjs_allLayersInDrawingOn</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
                </page>
        </pages>
        <icons_per_row>0</icons_per_row>
        <icon_page_left_x>0</icon_page_left_x>
        <icon_page_left_y>0</icon_page_left_y>
        <customcommand>
                <tooltip>Command tooltip 1</tooltip>
                <tooltip>Command tooltip 2</tooltip>
                <tooltip>Command tooltip 3</tooltip>
                <tooltip>Command tooltip 4</tooltip>
                <tooltip>Command tooltip 5</tooltip>
                <tooltip>Command tooltip 6</tooltip>
                <tooltip>Command tooltip 7</tooltip>
                <tooltip>Command tooltip 8</tooltip>
                <tooltip>Command tooltip 9</tooltip>
                <tooltip>Save Redline and Stickynotes</tooltip>
                <tooltip>Save Inserted Images</tooltip>
                <tooltip>Save Space Objects and Icon Objects</tooltip>
                <tooltip>Command tooltip 13</tooltip>
                <tooltip>Command tooltip 14</tooltip>
                <tooltip>Command tooltip 15</tooltip>
                <tooltip>Command tooltip 16</tooltip>
                <tooltip>Command tooltip 17</tooltip>
                <tooltip>Command tooltip 18</tooltip>
                <tooltip>Browse Folder Structure</tooltip>
                <tooltip>Select Property</tooltip>
        </customcommand>	
    </iconmenu>
    <zoommenu>
        <location_left_x>2</location_left_x>
        <location_left_y>40</location_left_y>
    </zoommenu>
    </cvjs>
    `,

  /*  Full CADViewer Menu for Viz Query  * /
  topMenuXML_config_file: `
    <cvjs>
    <iconmenu>
        <totalpages>3</totalpages>
        <startpage>1</startpage>
        <pages>
            <page>
                <command>cvjs_customCommand_19</command>
                <command>cvjs_Print</command>
                <command>cvjs_LayerList</command>
                <command>cvjs_interactiveLayerOff</command>
                <command>cvjs_swapLayersInDrawing</command>
                <command>cvjs_allLayersInDrawingOn</command>
                <command>cvjs_toggleBlackWhite</command>
                <command>cvjs_setBackgroundColor</command>
                <command>cvjs_interactiveSearchText</command>
                <command>cvjs_Measurement</command>
                <command>cvjs_calibrateMeasurement</command>
                <command>cvjs_displayMagnifyingGlass</command>
                <command>cvjs_activateLineThicknessModal</command>
                <command>cvjs_compareDrawings_LoadSecondDrawing</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
                </page>
            <page>
                <command>cvjs_loadStickyNotesRedlinesUser</command>
                <command>cvjs_saveStickyNotesRedlinesUser</command>
                <command>cvjs_publishPDF</command>
                <command>cvjs_saveAsSVGOnServer</command>
                <command>cvjs_setRedlineColor</command>
                <command>cvjs_setRedlineThickness</command>
                <command>cvjs_drawStickyNote</command>
                <command>cvjs_drawRedlineText</command>
                <command>cvjs_drawRedline_Freehand</command>
                <command>cvjs_drawRedlineSingleLine</command>
                <command>cvjs_drawRedlineEllipseCloud</command>
                <command>cvjs_drawRedlineFilledPolygon</command>
                <command>cvjs_drawRedlinePolyline</command>
                <command>cvjs_drawRedlineFilledRectangle</command>
                <command>cvjs_drawRedlineRectangle</command>
                <command>cvjs_drawRedlineTriangle</command>
                <command>cvjs_drawRedlineArrow</command>
                <command>cvjs_moveRedline</command>
                <command>cvjs_resizeRedline</command>
                <command>cvjs_rotateRedline</command>
                <command>cvjs_deleteSingleRedline</command>
                <command>cvjs_deleteLastRedline</command>
                <command>cvjs_undoDeleteLastRedline</command>
                <command>cvjs_clearCurrentRedline</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
            </page>
            <page>
                <command>cvjs_customCommand_19</command>
                <command>cvjs_loadSpaceObjectsUser</command>
                <command>cvjs_saveSpaceObjectsUser</command>
                <command>cvjs_saveAsSVGOnServer</command>
                <command>cvjs_changeSpaceObjectDisplayMode</command>
                <command>cvjs_addPolygonSpaceObject</command>
                <command>cvjs_addRectangleSpaceObject</command>
                <command>cvjs_addCircleSpaceObject</command>
                <command>cvjs_copyCircleSpaceObject</command>
                <command>cvjs_resizeSpaceObject</command>
                <command>cvjs_moveSpaceObject</command>
                <command>cvjs_rotateSpaceObject</command>
                <command>cvjs_deleteSpaceObject</command>
                <command>cvjs_clearSpaceObjects</command>
                <command>cvjs_bringToFront</command>
                <command>cvjs_sendToBack</command>
                <command>cvjs_bringForward</command>
                <command>cvjs_sendBackward</command>
                <command>cvjs_insertImageLink</command>
                <command>cvjs_loadAllImageLinks</command>
                <command>cvjs_saveAllImageLinks</command>
                <command>cvjs_clearAllImageLinks</command>
                <command>cvjs_quickCount</command>
                <command>cvjs_showMeCounts</command>
                <command>cvjs_clearQuickCounts</command>
                <command>cvjs_LayerListSpace</command>
                <command>cvjs_swapLayersInDrawing</command>
                <command>cvjs_allLayersInDrawingOn</command>
                <command>cvjs_About</command>
                <command>cvjs_Settings</command>
                <command>cvjs_Help</command>
                </page>
        </pages>
        <icons_per_row>0</icons_per_row>
        <icon_page_left_x>0</icon_page_left_x>
        <icon_page_left_y>0</icon_page_left_y>
        <customcommand>
                <tooltip>Command tooltip 1</tooltip>
                <tooltip>Command tooltip 2</tooltip>
                <tooltip>Command tooltip 3</tooltip>
                <tooltip>Command tooltip 4</tooltip>
                <tooltip>Command tooltip 5</tooltip>
                <tooltip>Command tooltip 6</tooltip>
                <tooltip>Command tooltip 7</tooltip>
                <tooltip>Command tooltip 8</tooltip>
                <tooltip>Command tooltip 9</tooltip>
                <tooltip>Command tooltip 10</tooltip>
                <tooltip>Command tooltip 11</tooltip>
                <tooltip>Command tooltip 12</tooltip>
                <tooltip>Command tooltip 13</tooltip>
                <tooltip>Command tooltip 14</tooltip>
                <tooltip>Command tooltip 15</tooltip>
                <tooltip>Command tooltip 16</tooltip>
                <tooltip>Command tooltip 17</tooltip>
                <tooltip>Command tooltip 18</tooltip>
                <tooltip>Browse Folder Structure</tooltip>
                <tooltip>Select Property</tooltip>
        </customcommand>	
    </iconmenu>
    <zoommenu>
        <location_left_x>2</location_left_x>
        <location_left_y>40</location_left_y>
    </zoommenu>
    </cvjs>
    `,

  //*/

  setUnitForCalibrate: "feet", // set base unit for calibrate modal
  // DRAWING BASE LINE WEIGHT
  adjustMinimumLineThickness: 200, // Line minimum thickness, in percentage of the minimum line weight in the loaded drawing

  setNoModalMode: false, // set no highlight modal mode to true or false
  /*
    // CONTROL OF POPUP MODAL
    "popupCustomMenu1" : "Custom<br>Menu 1<br>",               // custom menu 1   -  my_own_clickmenu1 in CADViewer.js
    "popupCustomFontAwesomeIcon1" : "fa fa-info-circle",               // custom menu 1 - icon 1 
    "popupCustomMenu2" : "Custom<br>Menu 2<br>",               // custom menu 2 - my_own_clickmenu2 in CADViewer.js
    "popupCustomFontAwesomeIcon2" : "fa fa-undo",               // custom menu 2  - icon 2
    // */

  //* change in property section

  CADViewerPublicDemo: true, // set the CADViewerPublicDemo to true or false

  // SETTINGS OF THE COLORS OF SPACES  - blue base colors
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": "0.1", //"0.1",   // 0.1
    stroke: "#CCC",
    "stroke-width": "0.1",
    "stroke-linejoin": "round",
    "stroke-opacity": "0.0",
  },

  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": "0.5",
    stroke: "#a4d7f4",
    "stroke-width": "0.2",
  },

  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": "0.5",
    stroke: "#5BBEF6",
    "stroke-width": "0.23",
  },
  setSpaceNameAsTypeInPopup: false, // set space name as type in popup to true or false

  //            */

  /* /  COLOR OBJECTS FOR HIGHLIGHTS 
    // Base attributes of Space Object   - red/pink
    "BaseAttributes" : {
        "fill": "#d8e1e3", //'#d8e1e3', // '#ffd7f4', //'#D3D3D3',   // #FFF   #ffd7f4
        "fill-opacity": "0.1",
        "stroke": "#CCC", //  #CCC
        "stroke-width": 0.5,
        "stroke-opacity": "0.1",
        "stroke-linejoin": "round",
    },
    // Mouse over highlight attributes of Space Object
    "HighlightAttributes" : {
        "fill": "#ffd7f4", //"#a4d7f4",  // '#ffd7f4'
        "fill-opacity": "0.6",
        "stroke": "#ffd7f4", // "#a4d7f4",
        "stroke-width": 1,
        "stroke-opacity": "0.8",
    },
    // Mouse click highlight attributes of Space Object
    "SelectAttributes" : {
        "fill": "#ed39a5", //"#5BBEF6",   //#ed39a5
        "fill-opacity": "0.6",
        "stroke": "#ed39a5", //"#5BBEF6",  // #ed39a5
        "stroke-width": 1,
        "stroke-opacity": "0.8",
    },
    // */

  setRedlineModeInfo: false, // set redline mode info to true or false
  setRedlineDynamicPath: true, // set redline dynamic path to true or false , this will ensure one redline location per drawing
  setSpaceObjectDynamicPath: true, // set space object dynamic path to true or false , this will ensure one space object location per drawing
  setImageObjectDynamicPath: true, // set imageobject dynamic path to true or false , this will ensure one image object location per drawing

  setCADViewerSkin: "dark-skin", //CADViewer Skin light-skin, dark.skin, lightgray, black, deepblue

  // enable or disable top bar features
  enableLoginFeature: true, // SET THE logon interface for users
  // enable or disable features in ... right side icon
  rightMenuMode: "Inline", // Popup, Inline
  rightMenuPopupText: "Open Menu",
  enableRightMenuIcon: true,
  enableRightFileModalPanel: true,
  enableRightFileModalPanelText: "Folder Structure", //"Dateiordnerstruktur", //"Structure des dossiers", //"Folder Structure",   //
  rightFileModalPanelTitle: "Folder Structure", //"Dateiordnerstruktur", //"Structure des dossiers", //"Folder Structure",   //
  rightFileModalPanelSubTitle: "Drill down to select file", //"Explorez pour sélectionner le fichier", //"Drill down to select file",

  enableRightEmployeePanel: false,
  enableRightEmployeePanelText: "Employees",
  enableRightArchivePanel: false,
  enableRightArchivePanelText: "Archive",

  layerOptionWidth: 460, // in pixels
  rightActionPanelWidth: 600, //Todo in pixels
  planFile: "plan.json",
  planTypeText: "Plan",
  planSubTypeText: "Type",

  // controls for redline text
  setforeignObjectInRedlineText: true, // set foreign object in redline text to true or false

  // Tooltip text
  hambugerMenuTooltip: "Open/Close Left Panel",
  rightActionPanelTooltip: "Open Options Panel",
  leaseStartDate: "Lease Start Date",
  leaseEndDate: "Lease End Date",

  // Left Panel
  defaultLeftPanelOpen: false,

  // 1900-01-01T00:00:00 or 1900-01-01    - search of date-types for modification
  dateRegex: [
    "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}$",
    "^\\d{4}-\\d{2}-\\d{2}$",
  ],

  // Action panel side settings
  actionPanelSide: "left", // left, right,   settings of the action panel side

  // Upload files features
  maxUploadSize: "10", // maximun size in mb

  // Top Bar Logo
  topBarLogo: "", //"SNCF_reseau_01.png", // "",//"B-prop_logo_rgb.png", //"", //"SNCF_reseau_01.png" , // "SNCF Reseau    //  BPRetail "B-prop_logo_rgb.png", // "https://cadviewer.com/images/cadviewer/cv-logo.gif"
  cadViewerBrandLogoPosition: "right_center", // bottom_center right_center
  cadViewerBrandLogoSize: "small", // small large
  // Compare tool for JSON input files with structured content
  showCompareTool: false,
  // todo Configuration for display logo in toolbar and also position and which one is hide when left pane is open or close

  enablePolygonControlPoints: true, // enable or disable polygon control points

  // HELPER SECTION - CUSTOM COMPONENTS

  // helpers components   - NOTE: add your helper components in the CADViewerHelperMthods folder structure
  enableHelperMethods: false,
  enableHelpersMethodsGroup_Highlight: true,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  helperMethodsActionSize: 'small' as "small" | "normal" | "large", // small, normal, large
  // add your own group of helper methods on the top toolbar

  // SECTION FOR PROPERTY MANAGEMENT

  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: false, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items

  //
  customOnLoadEndContent: false, // custom OnLoadEnd content -processing of custom content in CADViewer.js
  //

  //    Global Application Files
  //   Global location for property / plans navigation:
  globalApplicationPlans: "plans.json",
  globalApplicationViews: "views.json",
  globalApplicationSearch: "search.json",

  /*
  //    Property Specific Files

  globalApplicationFilesLocation:
    "https://zthcvtest.blob.core.windows.net/test-cadviewer/json/application/",
  propertySVGFilesLocation:
    "https://zthcvtest.blob.core.windows.net/test-cadviewer/svg/",
  propertyJSONFilesLocation:
    "https://zthcvtest.blob.core.windows.net/test-cadviewer/json/property/",
*/

  //*

  globalApplicationFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/BPRetail/zthcvtest.blob.core.windows.net/test-cadviewer/json/application/",
  propertySVGFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/BPRetail/zthcvtest.blob.core.windows.net/test-cadviewer/svg/",
  propertyJSONFilesLocation:
    "https://server.demo.cadviewer.com/content/custom/BPRetail/zthcvtest.blob.core.windows.net/test-cadviewer/json/property/",
  // */

  /* proper links
    "globalApplicationFilesLocation" :"https://cadviewer.com/test-cadviewer/json/application/",
    "propertySVGFilesLocation" :"https://cadviewer.com/test-cadviewer/svg/",
    "propertyJSONFilesLocation" :"https://cadviewer.com/test-cadviewer/json/property/",
    // */

  //* proper links
  //"globalApplicationFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v3/json/application/",
  //"propertySVGFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v3/svg/",
  //"propertyJSONFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v3/json/property/",

  // "globalApplicationFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v2/json/application/",
  // "propertySVGFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v2/svg/",
  // "propertyJSONFilesLocation" :"https://zthcvtest.blob.core.windows.net/test-cadviewer/v2/json/property/",
  //
  /*"globalApplicationFilesLocation" :"https://bprcadviewer.blob.core.windows.net/test-cadviewer/json/application/",
    "propertySVGFilesLocation" :"https://bprcadviewer.blob.core.windows.net/test-cadviewer/svg/",
    "propertyJSONFilesLocation" :"https://bprcadviewer.blob.core.windows.net/test-cadviewer/json/property/",
    // */

  //* proper links  - v3 full update

  /*
    "globalApplicationFilesLocation" : "https://server.demo.cadviewer.com/content/custom/bpretail/zthcvtest.blob.core.windows.net/json/application/",
    "propertySVGFilesLocation" : "https://server.demo.cadviewer.com/content/custom/bpretail/zthcvtest.blob.core.windows.net/svg/",
    "propertyJSONFilesLocation" : "https://server.demo.cadviewer.com/content/custom/bpretail/zthcvtest.blob.core.windows.net/json/property/",
*/

  //    Property Specific Files

  // https://cadviewer-conversion-server-test.bpretail.com/content/custom/bpretail/bpretail-splash-04.svg

  enableRightJSONModalPanel: false, // enabling JSON load right side pane for property selection
  enableRightJSONModalPanelText: "Select Property", // test for JSON load right side pane
  enableRightJSONModalPanelText2:
    "Select a plan type, property, and floor plan to load the associated data.", // the second text line appearing on the Property Pane
  searchRightJSONModalPanelPlaceholder: "Search for property or occupant...", // the placeholder text appearing in the search field

  // quick print
  suppressPublishPDFModal: true, // the standard publishPDF modal is suppressed and replaced with QuickPDF

  enableQuickPdfPrint: true, // enabling quick pdf print
  enableQuickPdfPrintText: "Quick PDF", // test for JSON load right side pane
  enableQuickPdfPrintModalTitle: "Quick PDF Print", // the second text line appearing on the Property Pane
  enableQuickPdfPrintModalSubTitle:
    "Download a PDF with the current information plan/layer", // the second text line appearing on the Property Pane
  quickPDF_default_resolution: 600, // default resolution of quick pdf generation
  quickPDF_1_Resolution: 300, // resolution of quick pdf generation
  quickPDF_2_Resolution: 600, // resolution of quick pdf generation
  quickPDF_3_Resolution: 600, // resolution of quick pdf generation
  quickPDF_1_papersize: "letter", // resolution of quick pdf generation
  quickPDF_2_papersize: "letter", // resolution of quick pdf generation
  quickPDF_3_papersize: "tabloid", // resolution of quick pdf generation
  quickPDF_1_text: "Quick PDF", // resolution of quick pdf generation
  quickPDF_2_text: "Medium Resolution PDF", // resolution of quick pdf generation
  quickPDF_3_text: "High Resolution PDF", // resolution of quick pdf generation
  quickPDF_1_placeholder: "Standard output (letter/300dpi)", // resolution of quick pdf generation
  quickPDF_2_placeholder:
    "Increased dpi (letter/600dpi), longer processing time", // resolution of quick pdf generation
  quickPDF_3_placeholder:
    "Maximum dpi and size (tabloid/600dpi), resource demanding", // resolution of quick pdf generation
  quickPDFProcessingText: "Processing PDF, please wait...", // resolution of quick pdf generation

  // config for pdf Report in json panel
  enableJsonPDFReport: true, // enabling pdf report
  enableJsonPDFReportText: "PDF Report", // test for JSON load right side pane,
  enableJsonPDFReportModalTitle: "PDF Report", // the second text line appearing on the Property Pane
  enableJsonPDFReportModalSubTitle:
    "Download a PDF with the current information plan/layer", // the second text line appearing on the Property Pane
  jsonPDFReportPreselectFirstItemInList: true,
  jsonPDFReportSelectViewLabel: "Select View",
  jsonPDFReportSelectViewSubtitle:
    "Select the view/information plan for the report",
  jsonPDFReportSelectPlanLabel: "Select Plan",
  jsonPDFReportSelectPlanSubtitle:
    "Select one or more plans from the list below, click again to select",
  jsonPDFReportSelectResolutionLabel: "Select Resolution",
  jsonPDFReportSelectResolutionSubtitle:
    "Select the resolution for the PDF report",
  jsonPDFReport_default_resolution: 600, // default resolution of quick pdf generation
  jsonPDFReport_1_Resolution: 300, // resolution of quick pdf generation
  jsonPDFReport_2_Resolution: 600, // resolution of quick pdf generation
  jsonPDFReport_3_Resolution: 600, // resolution of quick pdf generation
  jsonPDFReport_1_papersize: "letter", // resolution of quick pdf generation
  jsonPDFReport_2_papersize: "letter", // resolution of quick pdf generation
  jsonPDFReport_3_papersize: "tabloid", // resolution of quick pdf generation
  jsonPDFReport_1_text: "Quick PDF", // resolution of quick pdf generation
  jsonPDFReport_2_text: "Medium Resolution PDF", // resolution of quick pdf generation
  jsonPDFReport_3_text: "High Resolution PDF", // resolution of quick pdf generation
  jsonPDFReport_1_placeholder: "Standard output (letter/300dpi)", // resolution of quick pdf generation
  jsonPDFReport_2_placeholder:
    "Increased dpi (letter/600dpi), longer processing time", // resolution of quick pdf generation
  jsonPDFReport_3_placeholder:
    "Maximum dpi and size (tabloid/600dpi), resource demanding", // resolution of quick pdf generation
  jsonPDFErrorSelectView: "No view selected",
  jsonPDFErrorSelectPlan: "No plan selected",
  jsonPDFErrorSelectResolution: "No resolution selected",
  jsonPDFPrintTextButton: "Download PDF",

  // CONTROL OF POPUP MODAL   - UNCOMMENT CONTROL OF POPUP MODAL ABOVE WHEN ACTIVATING BELOW
  //*
  popupCustomMenu1: "Tenant<br>Info<br>", // custom menu 1   -  my_own_clickmenu1 in CADViewer.js
  popupCustomFontAwesomeIcon1: "fa fa-info-circle", // custom menu 1 - icon 1
  popupCustomMenu2: "Future <br>Tenant<br>", // custom menu 2 - my_own_clickmenu2 in CADViewer.js
  popupCustomFontAwesomeIcon2: "fa fa-undo", // custom menu 2  - icon 2
  cvjs_styleQTip_width: "240px", // set the width of the popup

  //   */
  //                  <command>cvjs_customCommand_20</command>   Select Property
  /* UNCOMMENT topMenuXML_config_file ABOVE WHEN ACTIVATING BELOW
    "topMenuXML_config_file" :  `
    <cvjs>
    <iconmenu>
        <totalpages>1</totalpages>
        <startpage>1</startpage>
        <pages>
            <page>
                <command>cvjs_Print</command>
                <command>cvjs_LayerList</command>
                <command>cvjs_toggleBlackWhite</command>
                <command>cvjs_setBackgroundColor</command>
                <command>cvjs_interactiveSearchText</command>
                <command>cvjs_Measurement</command>
                <command>cvjs_calibrateMeasurement</command>
                <command>cvjs_displayMagnifyingGlass</command>
                <command>cvjs_activateLineThicknessModal</command>
                <command>cvjs_setRedlineColor</command>
                <command>cvjs_setRedlineThickness</command>
                <command>cvjs_drawStickyNote</command>
                <command>cvjs_drawRedlineText</command>
                <command>cvjs_drawRedline_Freehand</command>
                <command>cvjs_drawRedlineEllipseCloud</command>
                <command>cvjs_drawRedlineFilledPolygon</command>
                <command>cvjs_drawRedlinePolyline</command>
                <command>cvjs_drawRedlineFilledRectangle</command>
                <command>cvjs_drawRedlineRectangle</command>
                <command>cvjs_drawRedlineArrow</command>
                <command>cvjs_deleteSingleRedline</command>
                <command>cvjs_deleteLastRedline</command>
                <command>cvjs_clearCurrentRedline</command>
                <command>cvjs_Help</command>
            </page>
            </pages>
            <icons_per_row>0</icons_per_row>
            <icon_page_left_x>0</icon_page_left_x>
            <icon_page_left_y>0</icon_page_left_y>
            <customcommand>
                <tooltip>Command tooltip 1</tooltip>
                <tooltip>Command tooltip 2</tooltip>
                <tooltip>Command tooltip 3</tooltip>
                <tooltip>Command tooltip 4</tooltip>
                <tooltip>Command tooltip 5</tooltip>
                <tooltip>Command tooltip 6</tooltip>
                <tooltip>Command tooltip 7</tooltip>
                <tooltip>Command tooltip 8</tooltip>
                <tooltip>Command tooltip 9</tooltip>
                <tooltip>Command tooltip 10</tooltip>
                <tooltip>Command tooltip 11</tooltip>
                <tooltip>Command tooltip 12</tooltip>
                <tooltip>Command tooltip 13</tooltip>
                <tooltip>Command tooltip 14</tooltip>
                <tooltip>Command tooltip 15</tooltip>
                <tooltip>Command tooltip 16</tooltip>
                <tooltip>Command tooltip 17</tooltip>
                <tooltip>Command tooltip 18</tooltip>
                <tooltip>Command tooltip 19</tooltip>
                <tooltip>Select Property</tooltip>
            </customcommand>	
        </iconmenu>
        <zoommenu>
            <location_left_x>2</location_left_x>
            <location_left_y>40</location_left_y>
        </zoommenu>
        </cvjs>
        `,                            

//    */

  //*
  //  COLOR OBJECTS FOR HIGHLIGHTS   - make fully transparent

  // Base attributes of Space Object
  /*
  BaseAttributes: {
    fill: "#ffffff", //'#d8e1e3', // '#ffd7f4', //'#D3D3D3',   // #FFF   #ffd7f4
    "fill-opacity": "0.0",
    stroke: "#CCC", //  #CCC
    "stroke-width": 0.0,
    "stroke-opacity": "0.0",
    "stroke-linejoin": "round",
  },

  // Mouse over highlight attributes of Space Object

  HighlightAttributes: {
    fill: "ffffff", //"#ffd7f4", //"#a4d7f4",  // '#ffd7f4'
    "fill-opacity": "0.0",
    stroke: "#ffd7f4", // "#a4d7f4",
    "stroke-width": 0.0,
    "stroke-opacity": "0.0",
  },

  // Mouse click highlight attributes of Space Object

  SelectAttributes: {
    fill: "#ffffff", //"#ed39a5", //"#5BBEF6",   //#ed39a5
    "fill-opacity": "0.0",
    stroke: "#ed39a5", //"#5BBEF6",  // #ed39a5
    "stroke-width": 1,
    "stroke-opacity": "0.8",
  },
*/
  //*/
  settingsGoHomepageButtonText: "Go Home",

  // enable or disable space objects extraction for left drawer menu (when json it's not available)
  enableSpaceObjectsExtraction: false,
  showTourInformationDialog: true,
  enableHelpButton1: true,
  helpbutton1: "CADViewer Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: true,
  helpbutton2: "CADViewer User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  customHtmlHeaderContent: `
     <!--  Update february 6th, 2023  only installed in May 29  -->
     <!-- Google tag (gtag.js) 2023-10-27 -->
     <script async src="https://www.googletagmanager.com/gtag/js?id=AW-1072657467"></script>
     <script>
       window.dataLayer = window.dataLayer || [];
       function gtag(){dataLayer.push(arguments);}
       gtag('js', new Date());
     
       gtag('config', 'AW-1072657467');
     </script>
     
     
     <!-- CRISP tag manager -->
     <script type="text/javascript"> window.$crisp=[];window.CRISP_WEBSITE_ID="50b89d34-074d-4a85-9a53-61c3705a2c51";(function(){ d=document;s=d.createElement("script"); s.src="https://client.crisp.chat/l.js"; s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})(); </script>
     
     <!--  Cookiehub 2.8.0   PRODUCTION  -->
     <script src="https://cdn.cookiehub.eu/c2/6524b042.js"></script>
     <script type="text/javascript">
     document.addEventListener("DOMContentLoaded", function(event) {
     var cpm = {};
     window.cookiehub.load(cpm);
     });
     </script>
     <script>
        function gtag_report_conversion(url) {
          const callback = function () {
            if (typeof(url) != 'undefined') {
              window.location = url;
            }
          };
          gtag('event', 'conversion', {
            'send_to': 'AW-1072657467/o15VCOOUpa0aELvovf8D',
            'value': 1.0,
            'currency': 'USD',
            'event_callback': callback
          });
          return false;
        }
     </script>
  `,
  enableGeoLocation: true,
  geolocationAPIKey: "70d6d7cb86ee89a766745277994579e77f122f1e13a4a3da81fa4150",
  recaptchaSiteKey: "6Ld8FhktAAAAAB7k9MwN6bWsYDAqwLbohbWw6yrQ",

  enableBasicAuth: false,
  basicAuthUsername: "admin",
  basicAuthPassword: "admin",

  // AI chat is not wired to a production endpoint on this deployment yet
  enableAIChat: false,
  useAIChatV4: false,
  useAIChatV5: false,

  // Remote distance query: enabled on the /public_demo presentation only
  // (its backend lives on server.ai.cadviewer.com). Off here on "/".
  enableDistanceQuery: false,
  distanceQueryApiPath: "/api/distance",

  omitSpaceObjectLayerHandling: false,
};

export default defaultConfig;
